<main class="flex min-h-screen flex-col">
  <app-header />
  <div class="grow px-8 py-12 lg:p-16 xl:px-24">
    <router-outlet />
  </div>
  <app-footer />
</main>
